/**
 * Attaches functionality to the afterContentShow and afterContentHide methods of [toggle]
 */

import {toggleOverlay} from '../helpers/born.utils';

export default class OverlayToggle {
	constructor(query) {
		let els = document.querySelectorAll(query);

		[].forEach.call(els, this.setCallbacks);
	}

	setCallbacks(el) {
		if (el.toggle) {
			let targetContent = el.toggle.contentEl,
			cancelWindowScroll = el.hasAttribute('data-toggle-scroll');
	
			targetContent.afterContentShow = function() {
				toggleOverlay(true, true);
	
				if(cancelWindowScroll) {
					document.documentElement.classList.add('cancel-scroll');
				}
			};
	
			targetContent.afterContentHide = function() {
				toggleOverlay();
	
				if(cancelWindowScroll) {
					document.documentElement.classList.remove('cancel-scroll');
				}
			};
		}
		
	}
}



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.overlaytoggle.js